enum GpDocTypePassVaccine {
  SecondRecord = 'VCDOC0',
  SecondCertificate = 'VCDOC1',
  ThirdCertificate = 'VCDOC2',
  ThirdInoculation = 'VCDOC3'
}

export default GpDocTypePassVaccine;
